export const CONGRATS_MODAL_NAME = 'congratsModal';
export const EXTERNAL_REDIRECTION_MODAL_NAME = 'externalRedirectionModal';
export const PROFILE_DRAWER_NAME = 'profileDrawer';
